import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useAuth } from "@/features/auth/hooks/useAuth";
import {
  preflightReportsInfiniteQueryOptions,
  type PreflightReportsListParams,
} from "@/lib/queries";
import type { PreflightReportSummary } from "../types/preflight.types";

/**
 * Wraps the infinite reports query and flattens pages into a single list (past-reports R1/R4).
 * `params.market` scopes the list to one market; omitting it lists every market (R8).
 */
export function usePreflightReports(params: PreflightReportsListParams = {}) {
  const activeTenantId = useAuth((s) => s.activeTenantId);
  const query = useInfiniteQuery(
    preflightReportsInfiniteQueryOptions(activeTenantId, params),
  );

  const reports = useMemo<PreflightReportSummary[]>(
    () => query.data?.pages.flatMap((page) => page.items) ?? [],
    [query.data],
  );

  return { ...query, reports };
}
